<template>
  <v-dialog v-model="dialog" max-width="900" scrollable @click:outside="$emit('update:activated', false)">
    <v-card>
      <v-card-title class="headline">Atributos Coringa:</v-card-title>
      <v-card-text>
        Caso esteja
        <i>desabilitado</i>
        , a simulação de baixas é processada com comportamento padrão, ou seja, dará baixa apenas se os atributos na base e no
        aquivo de baixas forem idênticos.
      </v-card-text>
      <v-card-text>
        Caso esteja
        <i>habilitado</i>
        , a simulação de baixas dará baixa se os atributos no aquivo de baixas
        <i>estiverem vazios (nulos)</i>
        ou caso sejam idênticos aos do base.
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="$emit('update:activated', false)">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    props: {
      activated: {
        type: Boolean,
        default: false
      }
    },

    emits: ['update:activated'],

    computed: {
      dialog() {
        return this.activated;
      }
    }
  };
</script>